import CommunicationProgramManagementContainer from './CommunicationProgramManagementContainer.js';

export default CommunicationProgramManagementContainer;